module.exports = __webpack_public_path__ + "img/PAGE02low.7d5c6b3a.jpg";